import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'

import { ProductsBlock } from '../HomePageContent/components/ProductsBlock/ProductsBlock'

import { ProductBlock } from './components/ProductBlock/ProductBlock'

type TProps = {}

const ProductPageContent: FC<TProps> = () => {
  return (
    <div className="flex flex-1 flex-col">
      <ProductBlock />
      <ResponsiveBlock>
        <Text tagName="span" className="">
          See also
        </Text>
      </ResponsiveBlock>
      <ProductsBlock />
    </div>
  )
}

export { ProductPageContent }
